import React from "react";

export default function SecondHomeContainer() {
  return (
    <div className="flex items-center justify-center h-screen bg-blue-100">
      <h1 className="text-5xl font-bold text-blue-700">
        Transfer container
      </h1>
    </div>
  );
}
